import React, { Component } from "react";
import styles from "./styles.scss";
import WWebView from "../../helpers/wwebview";
import WFirebase from "../../helpers/firebase";
import UserInfo from "../../helpers/userinfo";
import {
  //  isIOS,
  isAndroid,
} from "react-device-detect";

class EBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1,
    };
  }
  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    UserInfo.pullData();
  };
  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateWindowDimensions);
  };
  getRatio = (item) => {
    return item.width / item.height;
  };
  updateWindowDimensions = () => {
    const padding = {
      left: 5,
      top: 20,
    };
    const width = this.refs.out_wrapper.clientWidth - padding.left * 2;
    const height = this.refs.out_wrapper.clientHeight - padding.top * 2;
    const wrapper = {
      width: width,
      height: height,
      ratio: width / height,
    };
    const inner = {
      width: 320,
      height: 390,
      ratio: 320 / 390,
    };

    let scale = 1;
    if (wrapper.ratio > inner.ratio) {
      scale = wrapper.height / inner.height;
    } else {
      scale = wrapper.width / inner.width;
    }
    this.setState({ scale: scale });

    console.log(wrapper, inner);
  };

  render() {
    const { scale } = this.state;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 後來的Android改成這樣
    // App/com.farglory.community OS/android version/v3.3 build/33 APP-ID/com.farglory.mobile.new

    const isAppAndroid = isAndroid || /android/i.test(userAgent);

    return (
      <div className={styles.page_container}>
        <div className={styles.padding_container} ref="out_wrapper">
          {UserInfo.house_closing !== null && (
            <div
              className={styles.myContent}
              style={{
                transform: `scale(${scale})`,
              }}
            >
              {/* <img
                src={require("./imgs/library_img.png")}
                className={styles.books_img}
                alt="遠雄圖書雲"
              /> */}
              <div className="title">遠雄圖書雲</div>
              <div className="sub_title">
                超過4000本書籍、100種雜誌
                <br />
                300支親子天下影片
                {/* 藏書：3,000+ 
                  <br/>電子雜誌：3,000+ */}
              </div>
              <div className="using_title">使用方式</div>
              <div className="using_context">
                選擇使用平台(網頁/下載APP)
                <br />
                登入帳號與社區雲同
              </div>
              <div className="btn_container">
                {!isAppAndroid && (
                  <div
                    className="down_load_btn"
                    onClick={(e) => {
                      if (UserInfo.house_closing == 1) {
                        WFirebase.logEvent("Ebook_RAHouse", {
                          DWSiteIOS: UserInfo.houseid,
                        });
                      } else {
                        WFirebase.logEvent("Ebook_PS", {
                          DWSiteIOS: UserInfo.houseid,
                        });
                      }

                      window.location.href =
                        "https://itunes.apple.com/tw/app/遠雄圖書雲/id932352742?mt=8";
                    }}
                  >
                    <img
                      src={require("./imgs/btn_app_store.png")}
                      alt="app store"
                    />
                  </div>
                )}
                {isAppAndroid && (
                  <div
                    className="down_load_btn"
                    onClick={(e) => {
                      if (UserInfo.house_closing == 1) {
                        WFirebase.logEvent("Ebook_RAHouse", {
                          DWSiteAndroid: UserInfo.houseid,
                        });
                      } else {
                        WFirebase.logEvent("Ebook_PS", {
                          DWSiteAndroid: UserInfo.houseid,
                        });
                      }

                      WWebView.openURL(
                        "https://play.google.com/store/apps/details?id=tw.com.farglory.readerhd&hl=zh_TW"
                      );
                    }}
                  >
                    <img
                      src={require("./imgs/btn_google_play.png")}
                      alt="google play"
                    />
                  </div>
                )}
                <div
                  className="down_load_btn"
                  onClick={(e) => {
                    if (UserInfo.house_closing == 1) {
                      WFirebase.logEvent("Ebook_RAHouse", {
                        DWSiteWeb: UserInfo.houseid,
                      });
                    } else {
                      WFirebase.logEvent("Ebook_PS", {
                        DWSiteWeb: UserInfo.houseid,
                      });
                    }

                    WWebView.openURL("http://ebook.u-city.com.tw");
                  }}
                >
                  <img src={require("./imgs/btn_pc.png")} alt="pc" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EBook;



// WEBPACK FOOTER //
// ./src/views/EBook/EBook.js